import { FormattedMessage } from 'react-intl';
import { useAppNavigate } from '../../../configuration/setup/hooks';
import { type AppRoute, ROUTE_PERSONAL } from '../../app/routes/routes';

export const ConsentsBackButton = ({ isLoading }: { isLoading: boolean }) => {
    const navigate = useAppNavigate();
    const navigationTarget: AppRoute = ROUTE_PERSONAL;

    return (
        <button
            type={'button'}
            disabled={isLoading}
            onClick={e => {
                e.preventDefault();
                navigate(navigationTarget);
            }}
            className={'btn btn-primary'}
        >
            <span className={'uikit-icon icon-chevron-left'} />
            <FormattedMessage id={'intl-msg:registration.personalData.backButtonLabel'} />
        </button>
    );
};
